import axios from 'axios';

import { API_URL } from '../api/axios';

const getPublicProposal = (proposal_id, client_token) => {
  const response = axios.get(`${API_URL}/client/proposal/${proposal_id}?token=${client_token}`);

  return response;
};

const updatePublicProposal = (proposal_id, client_token, data) => {
  const response = axios.patch(`${API_URL}/client/proposal/${proposal_id}?token=${client_token}`, data);

  return response;
};

const getPublicSettings = () => {
  const response = axios.get(`${API_URL}/setting/company`);

  return response;
};

// Get proposal by permanent public token (no auth required)
const getProposalByPublicToken = (token) => {
  const response = axios.get(`${API_URL}/public/proposal/view/${token}`);

  return response;
};

const acceptOptionByToken = (token, optionId) => {
  const response = axios.post(`${API_URL}/public/proposal/view/${token}/accept-option/${optionId}`);
  return response;
};

const acceptOptionByClientToken = (proposalId, optionId, clientToken) => {
  const response = axios.post(`${API_URL}/client/proposal/${proposalId}/accept-option/${optionId}?token=${clientToken}`);
  return response;
};

const publicServices = {
  getPublicProposal,
  updatePublicProposal,
  getPublicSettings,
  getProposalByPublicToken,
  acceptOptionByToken,
  acceptOptionByClientToken,
};

export default publicServices;
